import React from 'react';

const BannerSection = () => {

  return (
    <>
    {/* banner-section */}
    <section className="banner-section p_relative">
            <div className="banner-carousel owl-theme owl-carousel owl-dots-none">
                <div className="slide-item p_relative">
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: `url("assets/images/shape/shape-2.png")`}}></div>
                        <div className="pattern-2" style={{backgroundImage: `url("assets/images/shape/shape-3.png")`}}></div>
                        <div className="eye-icon rotate-me" style={{backgroundImage: `url("assets/images/icons/icon-1.png")`}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="banner-content p_relative d_block">
                            <div className="content-box p_relative d_block z_5">
                                {/* <h3>Sunshine Advanced Eye Care</h3> */}
                                <h3 className="p_relative d_block fs_70 lh_80 fw_bold">Sunshine Advanced Eye Care</h3>
                                <p className="p_relative d_block fs_18">Sunshine Advanced Eye Care is a tertiary eye care center located in Kurnool. It is established in February, 2023 in an all new updated building.</p>
                                <div className="btn-box">
                                    <a href="/Contact" className="theme-btn btn-one">Contact Now</a>
                                </div>
                                <ul className="icon-list clearfix">
                                    <li><i className="icon-8"></i></li>
                                    <li><i className="icon-9"></i></li>
                                    <li><i className="icon-10"></i></li>
                                    <li><i className="icon-11"></i></li>
                                </ul>
                            </div>
                            <div className="image-box">
                                <div className="shape">
                                    <div className="shape-1" style={{backgroundImage: `url('assets/images/shape/shape-1.png')`}}></div>
                                    <div className="shape-2"></div>
                                </div>
                                <figure className="image"><img src="assets/images/banner/Sunshine_eye_care_7_examination_4.jpeg" alt="" /></figure>
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="slide-item p_relative">
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: `url('assets/images/shape/shape-2.png')`}}></div>
                        <div className="pattern-2" style={{backgroundImage: `url('assets/images/shape/shape-3.png')`}}></div>
                        <div className="eye-icon rotate-me" style={{backgroundImage: `url('assets/images/icons/icon-1.png')`}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="banner-content p_relative d_block">
                            <div className="content-box p_relative d_block z_5">
                                {/* <h3>Sunshine Advanced Eye Care</h3> */}
                                <h3 className="p_relative d_block fs_70 lh_80 fw_bold">Sunshine Advanced Eye Care</h3>
                                <p className="p_relative d_block fs_18">Dr. Spurthi Reddy has been well known for treating people from all over Andhra Pradesh since 2010. World class quality of eye care is our motto since inception with a well trained team of specialists, staff and high end equipment.</p>
                                <div className="btn-box">
                                    <a href="/Contact" className="theme-btn btn-one">Contact Now</a>
                                </div>
                                <ul className="icon-list clearfix">
                                    <li><i className="icon-8"></i></li>
                                    <li><i className="icon-9"></i></li>
                                    <li><i className="icon-10"></i></li>
                                    <li><i className="icon-11"></i></li>
                                </ul>
                            </div>
                            <div className="image-box style-two">
                                <div className="shape">
                                    <div className="shape-1" style={{backgroundImage: `url('assets/images/shape/shape-1.png')`}}></div>
                                    <div className="shape-2"></div>
                                </div>
                                <figure className="image"><img src="assets/images/banner/Sunshine_eye_care_20_examination_2.jpeg" alt="" /></figure>
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="slide-item p_relative">
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: `url('assets/images/shape/shape-2.png')`}}></div>
                        <div className="pattern-2" style={{backgroundImage: `url('assets/images/shape/shape-3.png')`}}></div>
                        <div className="eye-icon rotate-me" style={{backgroundImage: `url('assets/images/icons/icon-1.png')`}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="banner-content p_relative d_block">
                            <div className="content-box p_relative d_block z_5">
                                {/* <h3>Sunshine Advanced Eye Care</h3> */}
                                <h3 className="p_relative d_block fs_70 lh_80 fw_bold">Sunshine Advanced Eye Care</h3>
                                <p className="p_relative d_block fs_18">We solve all your eye care needs by providing personalized and holistic eye care for you and your family!</p>
                                <div className="btn-box">
                                    <a href="/Contact" className="theme-btn btn-one">Contact Now</a>
                                </div>
                                <ul className="icon-list clearfix">
                                    <li><i className="icon-8"></i></li>
                                    <li><i className="icon-9"></i></li>
                                    <li><i className="icon-10"></i></li>
                                    <li><i className="icon-11"></i></li>
                                </ul>
                            </div>
                            <div className="image-box style-three">
                                <div className="shape">
                                    <div className="shape-1" style={{backgroundImage: `url('assets/images/shape/shape-1.png')`}}></div>
                                    <div className="shape-2"></div>
                                </div>
                                <figure className="image"><img src="assets/images/banner/Sunshine_eye_care_22_examination.jpeg" alt="" /></figure>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </section>
        {/* banner-section end */}
    </>
    );
  }
  
  export default BannerSection;